import type { MaterialItem } from '@/mocks/types';

const STATUS_STYLE: Record<string, string> = {
  已归档: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  存疑: 'bg-accent-100 text-accent-900 border-accent-300',
  待核实: 'bg-background-200 text-foreground-700 border-background-300',
};

const TYPE_ICON: Record<string, string> = {
  音频: 'ri-mic-line',
  视频: 'ri-vidicon-line',
  截图: 'ri-image-line',
  图片: 'ri-image-2-line',
  文本: 'ri-file-text-line',
  表格: 'ri-table-line',
  文件: 'ri-file-line',
  记录: 'ri-history-line',
  日志: 'ri-terminal-box-line',
  分析: 'ri-line-chart-line',
  图表: 'ri-bar-chart-2-line',
};

export default function MaterialList({ materials }: { materials: MaterialItem[] }) {
  return (
    <div className="overflow-hidden rounded-lg border border-background-200">
      {materials.map((item, index) => (
        <div
          key={item.label}
          className={`flex flex-col gap-3 p-5 sm:flex-row sm:items-center ${
            index % 2 === 1 ? 'bg-background-100' : 'bg-background-50'
          } ${index > 0 ? 'border-t border-background-200' : ''}`}
        >
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className={`${TYPE_ICON[item.type] || 'ri-folders-line'} text-lg`}></i>
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-sm bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600">
                {item.type}
              </span>
              <strong className="text-sm font-medium text-foreground-900">{item.label}</strong>
            </div>
            <p className="mt-1 text-xs leading-relaxed text-foreground-500">{item.note}</p>
          </div>
          <span
            className={`w-fit shrink-0 whitespace-nowrap rounded-full border px-3 py-1 text-xs font-medium ${
              STATUS_STYLE[item.status]
            }`}
          >
            {item.status}
          </span>
        </div>
      ))}
    </div>
  );
}